import sliceCreator from '../../index.js';
import {UPDATE_ADMIN} from '../../../constants/index.js';
const _updateAdminAction = sliceCreator('UPDATE_ADMIN', UPDATE_ADMIN, 'put');

const { asyncAction: updateAdminAction, reducer, clearData: clearUpdateAdminAction } = _updateAdminAction;

export default reducer;

export {
    updateAdminAction,
    clearUpdateAdminAction
}